import services from '@/http';
import * as types from './mutations-types';

 const ActionRevokeSetData = (vuex, payload) => {
	return services.revoke.revokeSetData(payload).then(res => {
		return res.data.data
	})
}
 const ActionRevokeGetData = ({commit}, payload) => {
	return services.revoke.revokeGetData(payload).then(res => {
		if(res.data.data){
            commit(types.SET_PROFILE,  res.data.data);
        }
	})
}


export const ActionRevokeAll = (vuex, cgi_id) => {
	return services.accessLocations.revoke({cgi_id: cgi_id}).then(res => {								
		//if(res.data.data){
			//commit(types.DEL_LISTING,  accessLocation);
		//} 
		return res.data;                                
	});
}

export default {
	ActionRevokeSetData,
	ActionRevokeGetData,
	ActionRevokeAll
}